import _findIndex from 'lodash/findIndex';

import { updateComments } from 'actions/comments';
import { showErrorBar } from 'actions/errorBar';
import { ERROR } from 'constants/error-severities';
import {
  VIDEO_COMMENT_CREATED,
  VIDEO_COMMENT_REPLY_CREATED,
} from 'constants/events';
import * as analytics from 'utilities/analytics';
import { getGraphQLClient } from 'utilities/graphql';
import * as loggerx from 'utilities/loggerx';
import { replaceURLs } from 'utilities/mediumHelpers';

import CreateComment from './CreateVideoComment.gql';

// We are currently using the old API for comments, as well as the new GraphQL endpoint.
// This file will eventually replace comments.js as we migrate

// addCommentCreator will handle both top level comments and replies, switched by the presence of a parentPostId
export function addCommentCreator(
  content,
  parentPostId,
  anonUserName,
  creationMethod
) {
  const isCommentReply = Boolean(parentPostId);

  const urlInjectedContent = replaceURLs(content);

  return async (dispatch, getState) => {
    const player = getState().video_player;
    const comments = getState().comments.comments;

    const gqlClient = getGraphQLClient();

    let data;

    try {
      const response = await gqlClient.mutate({
        mutation: CreateComment,
        variables: {
          anonUserName,
          content: urlInjectedContent,
          mentions: [],
          parentPostId: parseInt(parentPostId),
          password: player.password,
          timestamp: Math.round(player.current_time),
          videoId: player.video.id,
        },
      });

      data = response.data;
    } catch (err) {
      dispatch(showErrorBar(ERROR, `Unable to create comment`));

      loggerx.error(
        err,
        { videoId: player.video.id, message: 'Error creating comment' },
        { team: 'create' }
      );

      return;
    }

    const newComment = data.createVideoComment;

    newComment.content = newComment.textContent;
    newComment.replies = newComment.replies || [];

    if (!isCommentReply) {
      dispatch(updateComments(comments.concat(newComment)));
    } else {
      const newComments = comments.slice(0);

      // the front end expects the parent post id to be a string
      newComment.comment_post_id = newComment.comment_post_id.toString();

      const parentCommentIndex = _findIndex(comments, {
        id: newComment.comment_post_id,
      });

      newComments[parentCommentIndex].replies.push(newComment);
      dispatch(updateComments(newComments));
    }

    analytics.track(
      isCommentReply ? VIDEO_COMMENT_REPLY_CREATED : VIDEO_COMMENT_CREATED,
      {
        comment_id: newComment.id,
        video_id: player.video.id,
        creation_method: creationMethod,
        comment_length: newComment.content.length,
      }
    );
  };
}
